export default {
    name: "create_cash_event",
    definition: {
        init: function () {
            this.jsonInit({
                "message0": 'create cash event with amount: %1currency: %2status: %3' +
                    'account ID: %4counter-account reference: %5counterparty: %6date: %7operation id: %8type: %9source: %10transaction reference: %11category: %12subcategory: %13ignore date shifts%14',
                "args0": [
                    {
                        "type": "input_value",
                        "name": "AMOUNT",
                        "check": "Number"
                    },
                    {
                        "type": "input_value",
                        "name": "CURRENCY",
                        "check": "String"
                    },
                    {
                        "type": "input_value",
                        "name": "STATUS",
                        "check": "String"
                    },
                    {
                        "type": "input_value",
                        "name": "ACCOUNT",
                        "check": ["String", "Account_Id"]
                    },
                    {
                        "type": "input_value",
                        "name": "TARGET_ACCOUNT",
                        "check": "Account_Reference"
                    }
                    , {
                        "type": "input_value",
                        "name": "COUNTERPARTY",
                        "check": "String"
                    },
                    {
                        "type": "input_value",
                        "name": "DATE",
                        "check": "String"
                    },
                    {
                        "type": "input_value",
                        "name": "OPERATION",
                        "check": "String"
                    },
                    {
                        "type": "input_value",
                        "name": "TYPE",
                        "check": "String"
                    },
                    {
                        "type": "input_value",
                        "name": "SOURCE",
                        "check": "String"
                    },
                    {
                        "type": "input_value",
                        "name": "TRANS_REFERENCE",
                        "check": "String"
                    },
                    {
                        "type": "input_value",
                        "name": "CATEGORY",
                        "check": "String"
                    },
                    {
                        "type": "input_value",
                        "name": "SUBCATEGORY",
                        "check": "String"
                    },
                    {
                        "type": "input_value",
                        "name": "IGNORE_DATE_SHIFTS",
                        "check": "Boolean"
                    }
                ],
                "nextStatement": true,
                "previousStatement": true,
                "colour": 4.5,
                "tooltip": "Creates cash event with specified parameters",
                "helpUrl": "http://www.w3schools.com/jsref/jsref_length_string.asp"
            });
        }
    },
    codeGenerator: (blocklyInstance) => function (block) {
        // String or array length.
        let params = ["AMOUNT", "CURRENCY", "STATUS", "ACCOUNT", "COUNTERPARTY", "DATE", "OPERATION", "TYPE", "SOURCE", "TRANS_REFERENCE", "TARGET_ACCOUNT", "CATEGORY", "SUBCATEGORY", "IGNORE_DATE_SHIFTS"];

        params = params.map(param => blocklyInstance.JavaScript.valueToCode(block, param,
            blocklyInstance.JavaScript.ORDER_ATOMIC));

        return `emitter.emitEvent(${params.join(",")});`;
    }
}
